import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=045e746c&"
import script from "./ContractDetail.vue?vue&type=script&lang=js&"
export * from "./ContractDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045e746c')) {
      api.createRecord('045e746c', component.options)
    } else {
      api.reload('045e746c', component.options)
    }
    module.hot.accept("./ContractDetail.vue?vue&type=template&id=045e746c&", function () {
      api.rerender('045e746c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/ContractDetail.vue"
export default component.exports